<!--政策法规-->
<template>
    <div class="studio_nav_content">
        <div class="content-container" v-show="showMode==='page'">
            <div class="zc-container">
                <div class="l-container">
                    <div class="tj-container">
                        <div :class="category?'tj-item':'tj-item-active'" @click="changeCategory('')">全部</div>
                        <div :class="category==='1'?'tj-item-active':'tj-item'" @click="changeCategory('1')">教育</div>
                        <div :class="category==='2'?'tj-item-active':'tj-item'" @click="changeCategory('2')">科技</div>
                        <div :class="category==='3'?'tj-item-active':'tj-item'" @click="changeCategory('3')">知识产权</div>
                    </div>
                    <div class="tj-container">
                        <div :class="subcategory?'tj-item':'tj-item-active'" @click="changeSubcategory('')">全部</div>
                        <div :class="subcategory==='1'?'tj-item-active':'tj-item'" @click="changeSubcategory('1')">国务院文件</div>
                        <div :class="subcategory==='2'?'tj-item-active':'tj-item'" @click="changeSubcategory('2')">国务院部门文件</div>
                    </div>
                </div>
                <div class="r-container">
                    <el-form-item class="pull-right">
                        <el-input v-model="queryParams.title" placeholder="请输入名称搜索" class="input-with-select">
                            <template #append>
                                <el-button type="primary" @click="pageList(null)" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                            </template>
                        </el-input>
                    </el-form-item>
                </div>
            </div>

            <div class="right-container">
                <div class="info-list-container">
                    <div class="zc-item" v-for="item in dataList" :key="item.zhengcId">
                        <div class="zc-title" @click="viewZhengc(item)">{{item.title}}</div>
                        <div class="zc-content" @click="viewZhengc(item)">{{item.wordContent}}</div>
                        <div class="tag-content">
                            <div class="tag-type" v-if="item.subcategory==='1'">国务院文件</div>
                            <div class="tag-type" v-if="item.subcategory==='2'">国务院部门</div>
                            <div class="tag-time">{{ timestampDate(item.releaseTime) }}</div>
                        </div>
                    </div>
                    <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                </div>
                <div class="page-container" >
                    <pageTag :background="true"
                             :pageSizes="[10, 20, 30]"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageList" />
                </div>
            </div>
        </div>

        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <zhengc-info :zhengc-id="this.zhengcId"
                         @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import {timestampDate} from "@/utils/date";
import pageTag from "@/components/Pagination/page.vue";
import {pageZhengc} from "@/api/admin/zhengc"
import zhengcInfo from "@/components/resourceCentre/zhengcInfo.vue";

export default {
    name:'zcfgResource',
    components:{zhengcInfo, pageTag, dataEmpty},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
        this.pageList()
    },
    data() {
        return {
            showMode:'page',
            category:'',
            subcategory:'',
            timestampDate,
            queryParams: {
                zhengcType:1,
                category:'',
                subcategory:'',
                title:'',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            zhengcId:'',
        }
    },
    methods: {
        pageList(){
            this.queryParams.category = this.category
            this.queryParams.subcategory = this.subcategory
            pageZhengc(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changeCategory(val){
            this.category = val;
            this.queryParams.category = val;
            this.pageList();
        },
        changeSubcategory(val){
            this.subcategory = val;
            this.queryParams.subcategory = val;
            this.pageList();
        },
        viewZhengc(item){
            this.showMode = "detail"
            this.zhengcId = item.zhengcId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
    }
}

</script>

<style lang="scss" scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
/*列表模式：白色卡片一屏显示，条目过多时仅列表内部滚动*/
.content-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
/*筛选区*/
.zc-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
}
.l-container{
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
}
.r-container{
    flex-shrink: 0;
    width: 300px;
}
/deep/ .el-form-item{
    margin-bottom: 0;
}
/deep/ .el-input{
    width: 100%;
}
.tj-container{
    display: flex;
    height: 30px;
    flex-shrink: 0;
}
.tj-item{
    width: auto;
    margin-right: 24px;
    line-height: 30px;
    color: #434343;
    cursor: pointer;
    font-size: 15px;
    white-space: nowrap;
    flex-shrink: 0;
}
.tj-item:hover{
    color: #ff7f2e;
}
.tj-item-active{
    width: auto;
    margin-right: 24px;
    line-height: 30px;
    color: #ff7f2e;
    font-weight: bold;
    cursor: pointer;
    font-size: 15px;
    border-bottom: 2px solid #ff7f2e;
    white-space: nowrap;
    flex-shrink: 0;
}
/*列表区*/
.right-container{
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.info-list-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.page-container{
    flex-shrink: 0;
    display: grid;
    place-items: center;
    width: 100%;
    padding-top: 12px;
    box-sizing: border-box;
}
.zc-item{
    width: 100%;
    border-bottom: 1px solid #eef2f7;
    padding: 4px 0 10px;
    margin-bottom: 4px;
    box-sizing: border-box;
}
.zc-title{
    width: 100%;
    height: 34px;
    line-height: 34px;
    font-weight: bold;
    color: #101010;
    font-size: 16px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.zc-title:hover{
    color: #ff7f2e!important;
}
.zc-content{
    width: 100%;
    line-height: 22px;
    color: #9e9e9e;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
    margin-bottom: 8px;
}
.tag-content{
    width: 100%;
    display: flex;
    align-items: center;
}
.tag-type{
    padding: 0 10px;
    margin-right: 12px;
    color: #5f89c6;
    border: 1px solid #dce8f7;
    border-radius: 6px;
    height: 26px;
    line-height: 26px;
    font-size: 13px;
}
.tag-time{
    padding: 0 10px;
    color: #5f89c6;
    border: 1px solid #dce8f7;
    border-radius: 6px;
    height: 26px;
    line-height: 26px;
    font-size: 13px;
}
/*详情模式：白色卡片，内容在卡片内滚动*/
.detail-mode{
    width: 100%;
    height: calc(100vh - 174px);
    overflow-y: auto;
    background: #ffffff;
    border-radius: 16px;
    padding: 10px;
    box-sizing: border-box;
}
</style>